import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum HospiceHispanicEthnicitiesEnum {
    none = 0 as number,
    NoNotOfHispanicLatinoOrSpanishOrigin = 1 as number,
    YesMexicanAmericanChicano = 2 as number,
    YesPuertoRican = 4 as number,
    YesCuban = 8 as number,
    YesAnotherHispanicLatinoOrSpanishOrigin = 16 as number,
    PatientUnableToRespond = 32 as number,
    PatientDeclinesToRespond = 64 as number
}
class HospiceHispanicEthnicitiesClass extends EnumWithDescription<HospiceHispanicEthnicitiesEnum> {
    public readonly enum = HospiceHispanicEthnicitiesEnum;
    public readonly enumName: string = "HospiceHispanicEthnicitiesEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HospiceHispanicEthnicitiesEnum>> = new Map([
        [
            "NoNotOfHispanicLatinoOrSpanishOrigin",
            {
                value: HospiceHispanicEthnicitiesEnum.NoNotOfHispanicLatinoOrSpanishOrigin,
                name: "A. No, not of Hispanic, Latino/a, or Spanish origin"
            }
        ],
        [
            "YesMexicanAmericanChicano",
            {
                value: HospiceHispanicEthnicitiesEnum.YesMexicanAmericanChicano,
                name: "B. Yes, Mexican, Mexican American, Chicano/a"
            }
        ],
        [
            "YesPuertoRican",
            {
                value: HospiceHispanicEthnicitiesEnum.YesPuertoRican,
                name: "C. Yes, Puerto Rican"
            }
        ],
        [
            "YesCuban",
            {
                value: HospiceHispanicEthnicitiesEnum.YesCuban,
                name: "D. Yes, Cuban"
            }
        ],
        [
            "YesAnotherHispanicLatinoOrSpanishOrigin",
            {
                value: HospiceHispanicEthnicitiesEnum.YesAnotherHispanicLatinoOrSpanishOrigin,
                name: "E. Yes, another Hispanic, Latino or Spanish origin"
            }
        ],
        [
            "PatientUnableToRespond",
            {
                value: HospiceHispanicEthnicitiesEnum.PatientUnableToRespond,
                name: "X. Patient Unable to respond"
            }
        ],
        [
            "PatientDeclinesToRespond",
            {
                value: HospiceHispanicEthnicitiesEnum.PatientDeclinesToRespond,
                name: "Y. Patient Declines to respond"
            }
        ]
    ]);
}

export const HospiceHispanicEthnicities = new HospiceHispanicEthnicitiesClass();
